<template>
  <div class="flex flex-wrap gap-2 justify-content-center">
    <Button
      v-show="showViewBtn"
      rounded
      type="button"
      icon="pi pi-search"
      size="small"
      v-tooltip.bottom="'Переглянути'"
      @click="$emit('viewFunc')"
    />
    <Button
      v-show="showEditBtn"
      rounded
      type="button"
      icon="pi pi-pencil"
      severity="success"
      v-tooltip.bottom="'Редагувати'"
      @click="$emit('editFunc')"
    />
    <Button
      v-show="showRemoveBtn"
      rounded
      type="button"
      icon="pi pi-trash"
      severity="danger"
      v-tooltip.bottom="'Видалити'"
      @click="confirm2()"
    />
  </div>
</template>

<script>
import Button from "primevue/button";

import { showConfirmDialog } from "@/helpers/dialog";

export default {
  components: { Button },
  props: {
    itemName: String,
    showViewBtn: {
      type: Boolean,
      default: true,
    },
    showEditBtn: {
      type: Boolean,
      default: true,
    },
    showRemoveBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["viewFunc", "editFunc", "removeFunc"],
  methods: {
    confirm2() {
      showConfirmDialog({
        message: "Підтвердіть видалення",
        header: `Видалити ${this.itemName}?`,
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        acceptLabel: "Видалити",
        rejectLabel: "Відмінити",
        defaultFocus: "reject",
        accept: () => {
          this.$emit("removeFunc");
        },
        reject: () => {},
      });
    },
  },
};
</script>
